// test1504
(1504 && 0);
